<script lang="ts">
	import RoundArrowBack from 'virtual:icons/ic/round-arrow-back';
	import { page } from '$app/stores';
	import { PUBLIC_SITE_NAME } from '$env/static/public';
	import Container from '@lib/components/global/Container.svelte';
	import notFoundIcon from '@lib/images/icons/3d/error-404.webp?enhanced';
	import serverErrorIcon from '@lib/images/icons/3d/error-500.webp?enhanced';
	import CallCsButton from '@lib/components/global/micro/CallCSButton.svelte';
	import type { Picture } from 'vite-imagetools';
	import { afterNavigate } from '$app/navigation';

	const { error, status } = $page;

	if (error) {
		switch (status) {
			case 404:
				if (error.message === 'Not Found') {
					error.message = 'Halaman tidak ditemukan';
				}
				break;
			default:
				error.message = 'Terjadi kesalahan, silahkan coba lagi atau hubungi CS';
				break;
		}
	}

	interface ErrorObject {
		image: Picture;
		message: { default: string; locale: string };
	}

	const errorObjects: Record<number, ErrorObject> = {
		404: {
			image: notFoundIcon,
			message: {
				default: 'Not Found',
				locale: 'Halaman tidak ditemukan'
			}
		},
		500: {
			image: serverErrorIcon,
			message: {
				default: 'Internal Server Error',
				locale: 'Terjadi kesalahan pada server, silahkan coba lagi'
			}
		}
	};

	const errorObj = errorObjects[status] || errorObjects[500];

	function handleErrorMessage() {
		let message = 'Terjadi kesalahan, silahkan coba lagi';

		if (error) {
			if (error.message === errorObj.message.default) message = errorObj.message.locale;
			else message = error.message;
		}

		return message;
	}

	let fromUrl = '/';

	afterNavigate(({ from }) => (fromUrl = from?.url.href || '/'));
</script>

<svelte:head>
	<title>{status}: {handleErrorMessage()} | {PUBLIC_SITE_NAME}</title>
</svelte:head>

<section class="grid min-h-dvh place-items-center">
	<Container>
		<div class="mx-auto w-full max-w-4xl text-center">
			<enhanced:img
				class="mx-auto w-full max-w-md"
				src={errorObj.image}
				alt="{status}: {handleErrorMessage()}"
			/>
			{#if error}
				<div class="mt-8 space-y-2.5">
					<p class="text-balance text-2xl font-semibold">
						Terjadi Kesalahan: {status}
					</p>
					<p>{handleErrorMessage()}</p>
				</div>
			{/if}
			<div class="mx-auto mt-6 grid max-w-md grid-cols-2 gap-2.5">
				<button
					on:click={() => (location.href = fromUrl)}
					type="button"
					class="btn btn-block rounded-full pre-md:btn-lg"
				>
					<RoundArrowBack class="text-xl" />
					Kembali
				</button>
				<CallCsButton
					class="btn btn-block static bg-green-600 text-gray-100 shadow-none pre-md:btn-lg hover:bg-green-700"
				/>
			</div>
		</div>
	</Container>
</section>
